import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvConfig, ENV_CONFIG } from '@beneficity/environment/types';
import { BaseInternalHttpClient } from './base-internal-http-client.service';

/**
 * Data Power (DP) Http Client can be injected into any
 * public services that are exposed via Data Power API Gateway
 * This custom client provides the proper serverURL.
 * https://gitlabhealth.highmark.com/atlas_labs/community/diginn-docs/blob/master/resources/member-portal/rest-services/base-http-client.md
 */
@Injectable({
  providedIn: 'root',
})
export class DPHttpClient extends BaseInternalHttpClient {
  constructor(
    protected http: HttpClient,
    @Inject(ENV_CONFIG) public envConfig: EnvConfig
  ) {
    super(http, envConfig);
    //provides baseURL (e.g. https://servicestenv7.highmark.com)
    this.serverURL = `${this.envConfig.serviceDomains.protocol}${this.envConfig.serviceDomains.dp}`;
  }
}
